import CashierServiceModel from "../CashierServiceModel";
import UserModel from "./UserModel";
import ProductModel from "./ProductModel";

export default class StockKeepingUnitModel extends CashierServiceModel {

  modelName() {
    return 'stock-keeping-units';
  }

  publicRoutes() {
    let routes = super.publicRoutes() || {};
    routes.fetch = process.env.VUE_APP_CASHIER_REPOSITORY_URL + '/api/v1/public/' + this.modelName();
    return routes;
  }

  defaults() {
    return {
      id: null,
      stripe_id: null,
      product_id: null,
      inventory_type: null,
      inventory_quantity: null,
      inventory_value: null,
      price: null,
      active: null,
      attrs: null,
      image: null,
      metadata: null,
      package_dimensions: null,
      created_at: null,
      updated_at: null,
      deleted_at: null
    }
  }

  // Attribute mutations.
  mutations() {
    return {
      id: (val) => (this.nullStringMutator(val)),
      stripe_id: (val) => (this.nullStringMutator(val)),
      product_id: (val) => (this.nullStringMutator(val)),
      inventory_type: (val) => (this.nullStringMutator(val)),
      inventory_quantity: (val) => (this.nullStringMutator(val)),
      inventory_value: (val) => (this.nullStringMutator(val)),
      price: (val) => (this.nullStringMutator(val)),
      active: (val) => (this.nullStringMutator(val)),
      attrs: (val) => (this.nullStringMutator(val)),
      image: (val) => (this.nullStringMutator(val)),
      metadata: (val) => (this.nullStringMutator(val)),
      package_dimensions: (val) => (this.nullStringMutator(val)),
      created_at: (val) => (this.nullStringMutator(val)),
      updated_at: (val) => (this.nullStringMutator(val)),
      deleted_at: (val) => (this.nullStringMutator(val))
    }
  }

  // Attribute validation
  validation() {
    return {}
  }

  getProduct() {
    return this.getRelatedModel(ProductModel, 'product');
  }

}
